// Smile Lee Orthodontics (Brand 2 - Chino Hills, Dr. David Lee). Single office.
// Backend: bondLocations.ts SMILE_LEE_CHINO_HILLS (catalog 0abf27d7, Edge loc 1,
// procedure 158). Spanish supported ("Hablamos Espanol").
//
// THEME COLORS: refined in Phase 3 from the live site (teal/turquoise brand).
import type { BrandConfig } from "./types";

export const smileLee: BrandConfig = {
  slug: "smile-lee",
  brandId: "smile_lee",
  brandName: "Smile Lee Orthodontics",
  logo: "https://smileleechinohills.com/wp-content/uploads/2024/06/SmileLeeOrtho_logoC_RGB.svg",
  phone: "(909) 628-7100",
  phoneHref: "tel:+19096287100",
  theme: { primary: "#09B4B4", primaryDark: "#2D3643" }, // scoured 2026-06-26: site CTA teal + brand navy
  locales: ["en", "es"],
  locations: {
    SMILE_LEE_CHINO_HILLS: {
      id: "SMILE_LEE_CHINO_HILLS",
      name: "Chino Hills",
      addressLines: ["3233 Grand Ave, Suite E", "Chino Hills, CA 91709"],
      mapsUrl: "https://maps.google.com/?q=3233+Grand+Ave+Suite+E+Chino+Hills+CA+91709",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { CHINO_HILLS: "SMILE_LEE_CHINO_HILLS", SMILE_LEE: "SMILE_LEE_CHINO_HILLS" },
  // Native booking restored (2026-07): backend mints the Edge Booking token via
  // the Turnstile/CapSolver public-token path. To revert to the Ortho2 SPA
  // handoff, uncomment the line below:
  // ortho2BookingUrl: "https://edgebooking.ortho2.com/search?catalog=0abf27d7-47b0-47cd-9fe1-21f3a903785c&code=umusgh",
};
